// src/components/rating.jsx
import React, { useState } from 'react';
import { addDoc, collection, serverTimestamp, updateDoc, doc, arrayUnion } from 'firebase/firestore';
import { db, auth } from '../firebase';
import toast from 'react-hot-toast';

const NAVY = '#001F3F';
const GOLD = '#B8860B';

export default function Rating({ bookingId, stylistId, onClose }) {
  const [stars, setStars] = useState(0);
  const [hoverStars, setHoverStars] = useState(0);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!auth.currentUser) {
      toast.error("Please login to review.");
      return;
    }
    
    setSubmitting(true);
    try {
      const review = {
        bookingId: bookingId || 'manual_entry',
        clientId: auth.currentUser.uid,
        clientName: auth.currentUser.displayName || 'Anonymous Client',
        stylistId: stylistId,
        stars: stars,
        comment: comment.trim(),
        createdAt: serverTimestamp(),
      };

      // 1. Save the review document
      await addDoc(collection(db, 'reviews'), review);
      
      // 2. Add star value to stylist's rating array for average calculation
      const stylistRef = doc(db, 'barbers', stylistId);
      await updateDoc(stylistRef, { 
        ratings: arrayUnion(stars) 
      });

      toast.success('Thanks for your review! 👑', {
        style: { background: NAVY, color: GOLD, border: `1px solid ${GOLD}` }
      });
      onClose?.();
    } catch (err) {
      console.error(err);
      toast.error('Failed to submit review.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={overlayStyle} onClick={(e) => e.target === e.currentTarget && onClose?.()}>
      <div style={modalStyle}>
        <h2 style={{ color: GOLD, fontSize: '1.8rem', fontWeight: '800', margin: '0 0 0.5rem' }}>
          Rate Experience
        </h2>
        <p style={{ opacity: 0.7, marginBottom: '1.5rem', fontSize: '0.9rem' }}>How was your service?</p>

        <div style={{ marginBottom: '2rem' }}>
          {[1, 2, 3, 4, 5].map((i) => (
            <span
              key={i}
              onClick={() => setStars(i)}
              onMouseEnter={() => setHoverStars(i)}
              onMouseLeave={() => setHoverStars(0)}
              style={{
                fontSize: '2.5rem',
                cursor: 'pointer',
                margin: '0 5px',
                color: i <= (hoverStars || stars) ? GOLD : '#444',
                transition: 'transform 0.2s ease',
                display: 'inline-block',
                transform: i <= (hoverStars || stars) ? 'scale(1.2)' : 'scale(1)',
              }}
            >
              ★
            </span>
          ))}
        </div>

        <textarea
          placeholder="Share your thoughts..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={3}
          style={textareaStyle}
        />

        <button 
          onClick={handleSubmit} 
          disabled={submitting || stars === 0} 
          style={{...submitBtnStyle, opacity: (submitting || stars === 0) ? 0.5 : 1}}
        >
          {submitting ? 'Submitting...' : 'Submit Review'}
        </button>

        <button onClick={onClose} style={skipBtnStyle}>Skip for now</button>
      </div>
    </div>
  );
}

const overlayStyle = { position: 'fixed', inset: 0, background: 'rgba(0, 0, 0, 0.9)', display: 'grid', placeItems: 'center', zIndex: 10000, padding: '1rem', backdropFilter: 'blur(8px)' };
const modalStyle = { background: NAVY, color: 'white', padding: '2.5rem 2rem', borderRadius: '28px', border: `1px solid rgba(184, 134, 11, 0.4)`, maxWidth: '400px', width: '100%', textAlign: 'center', boxShadow: '0 20px 40px rgba(0,0,0,0.6)' };
const textareaStyle = { width: '100%', padding: '1rem', borderRadius: '12px', background: 'rgba(255, 255, 255, 0.05)', border: `1px solid rgba(184, 134, 11, 0.2)`, color: 'white', fontSize: '0.9rem', resize: 'none', marginBottom: '1.5rem', outline: 'none' };
const submitBtnStyle = { width: '100%', background: GOLD, color: 'black', padding: '1rem', border: 'none', borderRadius: '50px', fontSize: '1rem', fontWeight: 'bold', cursor: 'pointer' };
const skipBtnStyle = { marginTop: '1rem', background: 'none', border: 'none', color: '#666', cursor: 'pointer', fontSize: '0.85rem' };
                   
